"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Dialog = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("../Typography"));

var S = _interopRequireWildcard(require("./styled"));

var ALIGNMENT_TO_FLEX = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};

var Dialog = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Dialog, _PureComponent);

  var _super = (0, _createSuper2["default"])(Dialog);

  function Dialog() {
    (0, _classCallCheck2["default"])(this, Dialog);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Dialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description,
          onClose = _this$props.onClose,
          isOpen = _this$props.isOpen,
          alignment = _this$props.alignment,
          maxWidth = _this$props.maxWidth,
          actions = _this$props.actions,
          icon = _this$props.icon;
      return /*#__PURE__*/_react["default"].createElement(S.Dialog, {
        open: isOpen,
        onClose: onClose,
        fullWidth: true,
        disableBackdropClick: true,
        maxWidth: maxWidth
      }, /*#__PURE__*/_react["default"].createElement(S.DialogContent, null, /*#__PURE__*/_react["default"].createElement(S.GridContent, {
        container: true,
        alignItems: ALIGNMENT_TO_FLEX[alignment],
        textAlign: alignment,
        direction: "column"
      }, /*#__PURE__*/_react["default"].createElement(S.IconWrapper, {
        item: true
      }, _react["default"].createElement(icon, {
        fontSize: 'large'
      })), /*#__PURE__*/_react["default"].createElement(S.HeadingWrapper, {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h4"
      }, title)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, typeof description === 'string' ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, description) : description))), /*#__PURE__*/_react["default"].createElement(S.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        alignItems: "center",
        justify: ALIGNMENT_TO_FLEX[alignment],
        spacing: 2
      }, actions.map(function (action) {
        return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          key: action.key
        }, action);
      }))));
    }
  }]);
  return Dialog;
}(_react.PureComponent);

exports.Dialog = Dialog;
Dialog.defaultProps = {
  alignment: 'center',
  maxWidth: 'xs',
  icon: _InfoOutlined["default"]
};
var _default = Dialog;
exports["default"] = _default;